// The in-page confirmation for deleting a sourcing event (Lane 1433), used by the
// events list and the event page. Only drafts and cancelled events can be deleted.
// A never-published event goes for good; a published (then cancelled) one only leaves
// the buyer's list, and suppliers keep the notices they were sent (server decides).
import React, { useState } from 'react';

export const DELETABLE = ['draft', 'cancelled'];

export function canDelete(event) {
  return Boolean(event) && DELETABLE.includes(event.status);
}

export function deleteMessage(event) {
  return event.published
    ? 'It is removed from your list. Suppliers keep the cancellation notice they were sent.'
    : 'It is removed for good, with its parts, suppliers, notes and documents. You cannot undo this.';
}

// event: { public_id, name, status, revision, published }. onDeleted(event) runs after
// the server confirmed. Errors stay in the panel.
export default function DeleteEventConfirm({ api, event, onDeleted, onCancel }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const confirm = async () => {
    setBusy(true);
    setError('');
    try {
      await api.deleteEvent(event.public_id, event.revision);
      onDeleted(event);
    } catch (e) {
      setError(e.message || 'The event was not deleted. Try again.');
      setBusy(false);
    }
  };

  return (
    <section className="srce-panel srce-col" role="alertdialog" aria-label="Delete event"
      data-testid="srce-delete-confirm">
      <span className="srce-crit">
        Delete <span className="srce-strong">{event.name}</span>?
      </span>
      <span>{deleteMessage(event)}</span>
      {error && <span className="srce-error" role="alert">{error}</span>}
      <span className="srce-row">
        <button type="button" className="srce-btn srce-btn--neg" disabled={busy} onClick={confirm}>
          {busy ? 'Deleting…' : 'Yes, delete'}
        </button>
        <button type="button" className="ll-clr" disabled={busy} onClick={onCancel}>Keep it</button>
      </span>
    </section>
  );
}
